import HelpIcon from '@mui/icons-material/Help'
import { Box, Divider, Grid2, Typography } from '@mui/material'
import Currency from 'components/Currency'
import CustomTooltip from 'components/Tooltip/Tooltip'
import { useWallet } from 'hooks/useWallet'
import { useEffect, useMemo } from 'react'
import useStyles from './styles'

export default function BalanceCard(): JSX.Element {
  const { classes } = useStyles()

  const { data, refetch } = useWallet()

  const { balance, walletBalance, rewardCredit, voucherCredit } = data ?? {}

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const walletCredit = useMemo(() => {
    return walletBalance ? Number(walletBalance) : 0
  }, [walletBalance])

  const rewardCreditPrice = useMemo(() => {
    return rewardCredit ? Number(rewardCredit) : 0
  }, [rewardCredit])

  const voucherCreditPrice = useMemo(() => {
    return voucherCredit ? Number(voucherCredit) : 0
  }, [voucherCredit])

  const totalBalance = useMemo(() => {
    return balance ? Number(balance) : 0
  }, [balance])

  return (
    <Grid2 container alignItems='center' className={classes.balanceCard}>
      <Grid2
        container
        size={{ xs: 12 }}
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
      >
        <Grid2>
          <Typography component='h3' variant='body1'>
            Goldie credit
          </Typography>
        </Grid2>
        <Grid2>
          <Typography component='h2' variant='h2'>
            <Currency amount={Number(totalBalance)} />
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 size={{ xs: 12 }}>
        <Divider />
      </Grid2>
      <Grid2 container justifyContent='space-between' size={{ xs: 12 }}>
        <Grid2>
          <Grid2>
            <CustomTooltip
              Icon={
                <Box display='flex' alignItems='center' gap={0.2}>
                  <Typography component='h4' variant='body1'>
                    Wallet credit
                  </Typography>
                  <HelpIcon style={{ fontSize: '1rem' }} color='white' />
                </Box>
              }
              title={`
              Wallet credit is money you have transferred to Goldie, or money from the proceeds of a you can use this to make more purchases or withdraw to your personal bank account.
              `}
              isHover
              showCloseIcon={false}
            />
          </Grid2>
          <Grid2>
            <Typography className={classes.balanceValue}>
              <Currency amount={Number(walletCredit)} />
            </Typography>
          </Grid2>
        </Grid2>

        <Grid2>
          <Grid2>
            <CustomTooltip
              Icon={
                <Box display='flex' alignItems='center' gap={0.2}>
                  <Typography component='h4' variant='body1'>
                    Reward credit
                  </Typography>
                  <HelpIcon style={{ fontSize: '1rem' }} color='white' />
                </Box>
              }
              title={`
              Credit from special promotions and referral bonuses, you can only use this to make a purchase and it cannot be withdrawn. It will have to be used within a certain timeframe
              `}
              isHover
              showCloseIcon={false}
            />
          </Grid2>
          <Grid2>
            <Typography className={classes.balanceValue} textAlign='center'>
              <Currency amount={Number(rewardCreditPrice)} />
            </Typography>
          </Grid2>
        </Grid2>

        <Grid2>
          <Grid2>
            <CustomTooltip
              Icon={
                <Box display='flex' alignItems='center' gap={0.2}>
                  <Typography component='h4' variant='body1'>
                    Voucher credit
                  </Typography>
                  <HelpIcon style={{ fontSize: '1rem' }} color='white' />
                </Box>
              }
              title={`
              Credit from the redemption of gifts, it cannot be withdrawn and must first be spent in a purchase
              `}
              isHover
              showCloseIcon={false}
            />
          </Grid2>
          <Grid2>
            <Typography className={classes.balanceValue}>
              <Currency amount={Number(voucherCreditPrice)} />
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  )
}
